import axios from "axios";

export const getBillingHistory = async (promocode) => {
  try {
    const url = `${process.env.REACT_APP_GET_BILLING_DETAILS}/${promocode}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {}
};

export const getChargebeeInvoice = async (id) => {
  try {
    const url = `${process.env.REACT_APP_GET_CHARGEBEE_INVOICE}/${id}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {}
};

export const getSubscription = async (data) => {
  try {
    const url = process.env.REACT_APP_GET_SUBSCRIPTION;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const listSubscription = async (data) => {
  try {
    const url = process.env.REACT_APP_LIST_SUBSCRIPTION;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {}
};

export const updateSubscription = async (data) => {
  try {
    const url = process.env.REACT_APP_UPDATE_SUBSCRIPTION;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updatePromoCode = async (data) => {
  try {
    const url = process.env.REACT_APP_UPDATE_PROMOCODE;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {}
};

export const updatePaymentMethod = async (email) => {
  try {
    const url = process.env.REACT_APP_UPDATE_PAYMENT_METHOD;
    const response = await axios.post(url, { email });
    return response.data;
  } catch (error) {}
};

export const cancelSubscription = async (data) => {
  try {
    const url = process.env.REACT_APP_CANCEL_SUBSCRIPTION;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {}
};

export const getBlenderCredits = async (data) => {
  try {
    const url = process.env.REACT_APP_GET_BLENDER_CREDITS;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {}
};

export const retrieveBlenderCredits = async (id) => {
  try {
    const url = process.env.REACT_APP_RETRIEVE_BLENDER_CREDITS;
    const response = await axios.post(url, { id });
    return response.data;
  } catch (error) {}
};

export const updateBlenderCredits = async (data) => {
  try {
    const url = process.env.REACT_APP_UPDATE_BLENDER_CREDITS;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {}
};

export const renewAnuualPlanApi = async (data) => {
  try {
    const url = process.env.REACT_APP_RENEW_ANNUAL_PLAN;
    const response = await axios.post(url, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
